import React, { useState } from 'react';
import { Button, DialogContent, DialogActions, TextField } from '@mui/material';
import { Dialog } from '@jbrowse/core/ui';
export function HTTPBasicLoginForm({ internetAccountId, handleClose, }) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    return (React.createElement(Dialog, { open: true, maxWidth: "xl", "data-testid": "login-httpbasic", title: `Log in for ${internetAccountId}` },
        React.createElement("form", { onSubmit: event => {
                if (username && password) {
                    handleClose(btoa(`${username}:${password}`));
                }
                else {
                    handleClose();
                }
                event.preventDefault();
            } },
            React.createElement(DialogContent, { style: { display: 'flex', flexDirection: 'column' } },
                React.createElement(TextField, { required: true, label: "Username", variant: "outlined", inputProps: { 'data-testid': 'login-httpbasic-username' }, onChange: event => setUsername(event.target.value), margin: "dense" }),
                React.createElement(TextField, { required: true, label: "Password", type: "password", autoComplete: "current-password", variant: "outlined", inputProps: { 'data-testid': 'login-httpbasic-password' }, onChange: event => setPassword(event.target.value), margin: "dense" })),
            React.createElement(DialogActions, null,
                React.createElement(Button, { variant: "contained", color: "primary", type: "submit" }, "Submit"),
                React.createElement(Button, { variant: "contained", color: "secondary", type: "submit", onClick: () => handleClose() }, "Cancel")))));
}
